var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadLogoReason = function SvgFadLogoReason(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 128.5,
    cy: 139.5,
    r: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.269 69.823 1.096 44.318 17.83 12.01s9.083-10.513 19.2-10.511c10.116.002 21.235 10.518 21.235 10.518l18.906-12.071-.243-44.513-38.081-23.376-39.943 23.625z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m93.91 110.084 32.732-19.52-.34-38.05L92.692 72.5zm1.83 4.806c1.827 0 12 6.919 12 6.919s9.187-10.227 20.026-9.894c10.838.333 21.319 10.165 21.319 10.165l14.32-8.436-34.5-18.498S93.911 114.89 95.74 114.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.673 209.814 38.832-23.109.486-21.446s-13.512-3.11-18.569-11.871c-5.056-8.762-1.642-23.15-1.642-23.15L87.873 118.9l-39.428 23.467-1.203 44.667 40.431 22.78z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m120.22 185.665-33.272-18.587-32.781 19.318 34.112 19.115zm3.247-3.988c-.915-1.583-.008-13.852-.008-13.852s-13.317-3.344-18.448-12.897c-5.13-9.552-1.99-23.045-1.99-23.045l-14.467-8.184 1.231 39.127s34.596 20.434 33.682 18.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.882 140.821-38.928-21.209-18.316 10.436s2.429 14.623-2.63 23.383c-5.06 8.76-18.594 11.63-18.594 11.63l1.001 21.41 38.67 22.046 39.285-21.292-.488-46.404z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m170.695 124.71.54 38.107 33.12 18.73-.502-39.099zm-4.077.182-11.992 6.932s2.129 14.571-3.579 23.79c-5.708 9.22-17.329 11.881-17.329 11.881l.146 14.62 32.27-19.63.484-37.593z"
  }))));
};
export { SvgFadLogoReason as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-logo-reason.1bc0948f.svg";